const zh = {
    login : "登录",
    register : "注册",
    reset : "重置",
    exit : "退出",
    personal : "个人中心",
    adminPage : "管理中心",
    mainPageTtile : "网上办事大厅",
    commitSuccess : "提交成功！",
    hello : "你好",
    action : "操作",
    add : "新增",
    edit : "修改",
    delete : "删除",
    save : "保存",
    cancel : "取消",
    uploadSuccess : "上传成功！",
    placeWriteForm : "请填写表单信息！",
    noDepartmentTip : "若您所在部门不在列表中，请联系网络与信息化办公室-周晗(zhouhan@cibr.ac.cn)",
    notice : {
        emailNotice : "邮箱通知",
        webNotice : "网页通知",
        notAllFalse : "必须选择一个通知，以便于接收系统信息！"
    },
    setting : {
        personalInfo : "个人信息",
        messageSetting :"通知管理",
        forBack : "意见反馈",
        editPwd : "修改密码"
    },
    webSit : {
        groupManager : "部门管理",
        userManager : "用户管理",
        urlManager:"链接管理",
        name : "网站名称",
        englishName : "网站英文名称",
        url : "链接",
        desc : "简介",
        englishDesc : "英文简介",
        imgUrl : "网站图片",
        statu : "状态",
    },
    depart : {
        manager :"部门管理",
        name : "部门名称",
        englishName :"部门英文名称",
        principal : "部门负责人",
        member:"部门成员",
        newDepart : "新增部门",
        noName :"部门名称不能为空",
        noAdmin : "部门负责人不能为空",

    },
    user : {
        role :"角色",
        email : "邮箱",
        password : "密码",
        newPwd : "新密码",
        noEmail : "请输入邮箱！",
        errEmail : "请输入cibr或nibs邮箱！",
        noPassword : "请输入密码！",
        lessLengthPwd : "密码至少为8位！",
        name : "真实姓名",
        englishName : "英文姓名",
        repeatPwd : "确认密码",
        validate : "验证码",
        getCode :"获取验证码",
        noName : "请填写真实姓名！",
        lessLengthName : "真实姓名长度不能小于2！",
        noEnglishName : "请填写英文名！",
        noValidate : "请填写验证码！",
        lessValidate : "验证码至少为6位数字",
        reloadCode : "秒后重新获取",
        forgetPwd : "忘记密码？",
        pwdLogin : "密码登录",
        group : "部门",
        noRepeatPwd : "请再次输入密码！",
        notSamePwd : "两次输入的密码不一致！",
        noGroup : "请选择部门！",
        placeWrite : "请填写完整个人信息！",
        sendCodeSuccess : "验证码已发送至您邮箱！",
        emailExist : "邮箱已注册，请更换邮箱！",
        create : "注册成功！",
        noUser : "用户不存在！",
        hasCountToLogin : "已有账号？去登录！",
        validateErr : "验证码必须为6位数字",
        manager :"用户管理"
    },
    err : {
        imgTypeErr :"请选择正确的图片文件['jpg','jpeg','png']",
        systemErr : "系统异常！",
        codeErr : "验证码校验失败！",
        pwdNotMatch : "密码错误！",
        imageTooBig : "文件太大，请选择小于2M的文件。"
    },
}
export default zh;